(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('teamsList', teamsList);

    /* @ngInject */
    function teamsList() {
        var directive = {
            bindToController: true,
            templateUrl: 'teams-list.tpl',
            controller: teamsListController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                searchModel: '=',
                topTen: '@'
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            scope.vm.currentMember = 0;
            scope.vm.toggler = true;
            scope.vm.membersToggle = function(current) {
                if(scope.vm.toggler == true && scope.vm.currentMember != current) {
                    scope.vm.toggler = scope.vm.toggler;
                } else {
                    scope.vm.toggler = !scope.vm.toggler;
                }
                scope.vm.currentMember = current;
                // console.log(scope.vm.currentMember, scope.vm.toggler);
            };

            scope.vm.getTeamSellers = function(currentTeamID) {
                return scope.vm.data.sellers.filter(function(seller) {
                    return parseInt(seller.team_id) === currentTeamID;
                });
            };

            scope.vm.getTeamGoal = function(currentTeamID) {
                var team = scope.vm.data.teams.find(function(t) {
                    return t.id == currentTeamID;
                });
                var teamGoal = 0;
                // if (team && team.goal ) {
                //     return team.goal;
                // }

                if (team && team.goal  && !scope.$root.project_has_opt('layoutCS')) {
                    return team.goal;
                }
                var ss = scope.vm.data.sellers.filter(function(seller) {
                    return parseInt(seller.team_id) === currentTeamID;
                });

                var sellersGoalSum = 0;
                if (ss.length) {
                    for(var i in ss) {
                        sellersGoalSum += parseInt(ss[i].hq.goal.value);
                    }
                }
                return sellersGoalSum;
            };
        }
    }

    /* @ngInject */
    function teamsListController ($scope) {
        $scope.selectTeam = function(teamId) {
            $scope.$root.selectedSeller = teamId;
        };
    }

})();